export default __webpack_public_path__ + "static/media/batman.11fb7d56.gif";